export default __webpack_public_path__ + "media/7d1ea2b47383498cae3532ca39438a0b0bd96e62b086509952209141af890408.svg";